import { deviceCommands } from './deviceCommands';
import { devicePanels } from './devicePanels';

export const devicesPlugin = (editor) => {
	deviceCommands(editor);
	devicePanels(editor);
};
